import { useRef, useState } from "preact/hooks";
import { llmPrompt } from "./prompt-format";
import { script, changePromptMode } from "./state";
import type { PromptMode } from "./script";

export function LlmPrompt() {
  const prompt = llmPrompt(script.value.mode);
  const promptText = useRef<HTMLTextAreaElement>(null);
  const [copyStatus, setCopyStatus] = useState("");
  async function copyPrompt() {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopyStatus(
        "Prompt copied. Paste it into your LLM and add what you want to say.",
      );
    } catch {
      promptText.current?.focus();
      promptText.current?.select();
      setCopyStatus(
        "Clipboard access is unavailable. The prompt is selected; use your device’s Copy command.",
      );
    }
  }

  return (
    <section class="prompt-page panel" aria-labelledby="llm-title">
      <div class="library-heading">
        <h2 id="llm-title">LLM prompt</h2>
        <a class="quiet" href="/">
          Back to script
        </a>
      </div>
      <p class="transfer-description">
        Copy this prompt into your LLM, then describe what you want to say.
        Import the generated JSON into your script.
      </p>
      <div class="prompt-mode">
        <label for="llm-mode">Prompt mode</label>
        <select
          id="llm-mode"
          value={script.value.mode || "teleprompter"}
          onChange={(event) => {
            changePromptMode(event.currentTarget.value as PromptMode);
            setCopyStatus("");
          }}
        >
          <option value="teleprompter">Teleprompter</option>
          <option value="cue-cards">Cue cards</option>
        </select>
      </div>
      <label for="llm-prompt">Prompt for your LLM</label>
      <textarea
        ref={promptText}
        id="llm-prompt"
        class="json-input"
        value={prompt}
        readOnly
        spellcheck={false}
      />
      <p class="copy-status" role="status">
        {copyStatus}
      </p>
      <div class="transfer-footer">
        <button type="button" class="primary" onClick={copyPrompt}>
          Copy LLM prompt
        </button>
      </div>
    </section>
  );
}
